export default __webpack_public_path__ + "static/media/goback.12560cd9.svg";